<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead style="background: #425058;">
          <tr>
            <th style="color: #fff;">Policy</th>
          </tr>
        </thead>
        <tbody>
          <tr style="cursor:pointer" v-for="policy in policies" :key="policy.value" @click="copyPolicy(policy.value)">
            <td>{{ policy.value }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      policies: [
        {
          value: '/race_licence/SF/<MEETING_TYPE>/<COUNTRY_CODE>/<STATE>, deny'
        },
        {
          value: '/race_licence/*/<MEETING_TYPE>/<COUNTRY_CODE>/<STATE>, allow'
        },
        {
          value: '/race_licence/<licence_source>/<MEETING_TYPE>/<COUNTRY_CODE>/*, allow'
        },
        {
          value: '/price/<PRICE_SOURCE>, allow'
        },
        {
          value: '/result/<PRICE_SOURCE>, allow'
        },
        {
          value: '/pricemanager/<GENERATED_PRICE_SOURCE>, allow'
        },
        {
          value: '/racecard/<RACE_CARD_SOURCE>, allow'
        },
        {
          value: '/srm/<PRICE_MANAGER_CLIENT_ID>, allow'
        },
        {
          value: '/object/<FIELD_DISALLOWED_OBJECT>/<FIELD_DISALLOWED_FIELD>, deny'
        },
        {
          value: '/object/*/*, allow'
        },
        {
          value: '/delay/0, allow'
        },
        {
          value: '/comments/<RACE, RUNNER or *>/<SOURCE>, allow'
        }
      ]
    }
  },
  props: {
    addPolicies: Function
  },
  methods: {
    copyPolicy (policy) {
      this.addPolicies(policy)
    }
  }
}
</script>
